import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';


@Component({
  selector: 'app-membcount',
  templateUrl: './membcount.component.html',
  styleUrls: ['./membcount.component.scss'],
})
export class MembcountComponent {
  loader: boolean = true;
  rolelist: any;
  orgObj: any;
  orgName;
  search;
  orgId: any = localStorage.getItem('custo.dashBoardOrgId');
  newOrgObject;
  roleCount: any
  orgs: any = []
  memblist: any = [];
  memblistCount: any;
  activeInd: boolean;
  active: boolean = false;
  schemename: any;
  membershipSchemeId: any;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    private bottomSheet: MatBottomSheet

  ) { }

  ionViewWillEnter() {
    this.active = false;
    sessionStorage.setItem('vendorApp', JSON.stringify(this.active))
    this.buyMemb1();
    this.getAllmemb();
  }
  // this.service.getOrg().subscribe((res:any)=>{
  //   if(this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')){
  //     this.orgs=res;
  //   }else{
  //     this.orgs=res.filter(res=>{ return res.id==localStorage.getItem('custo.dashBoardOrgId')})
  //   }
  //   this.orgs.map(res=>{
  //     if(res.id == localStorage.getItem('custo.dashBoardOrgId')){
  //       this.orgName = res.name
  //     }
  //   })
  // }, err => {
  //   this.handler.err(err);
  // })
  // getOrgs(){
  //   this.service.getOrg().subscribe((res:any)=>{
  //     this.orgs=res;
  //     .log(this.orgs)
  //   })
  // }

  getAllmemb() {
    this.loader = true;
    this.service.getAllmembership().subscribe(res => {
      if (res) {
        this.memblist = res;
        this.memblist = this.memblist.filter(res => res.activeInd === true);
        this.memblistCount = this.memblist.length;
        this.loader = false;
        this.memblist.forEach((res) => {
          if (res.id ===  this.membershipSchemeId) {
            Object.assign(res, { memberShipInd: true }); // Add allInd: true to the matching membership
          }
        });
        console.log(this.memblist)
      } else {
        this.rolelist = [];
        this.handler.res("No Data Found");
        this.loader = false;
      }
    }, err => {
      this.loader = false;
      this.handler.err(err)
    })
  }

  buyMemb(item) {
    console.log(item, "123");
    this.loader = true;
    var post = {
      "discount": item.discount,
      "cost": item.cost,
      "schemeValidityDays": item.schemeValidityDays,
      "membershipSchemeId": item.id,
      "membershipSchemeName": item.membershipSchemeName,

    }
    this.service.buyMembership(post).subscribe(res => {
      if (res) {
        this.handler.res("Membership Bought successfully");
        this.loader = false;
      } else {
        this.rolelist = [];
        this.handler.res("No Data Found");
        this.loader = false;
      }
    }, err => {
      this.loader = false;
      this.handler.res("You have already Purchased a MembershipPackage ")
    })
  }

  edit(id) {
    this.router.navigate(['/edit-memb', id]);
  }
  ionViewWillLeave() {
    // sessionStorage.clear();
    this.rolelist = [];
    this.search = "";
  }
  buyMemb1() {
    this.service.myMembership([]).subscribe((res: any) => {
      if (res) {
        this.schemename = res;
        this.membershipSchemeId = res.membershipSchemeId;
        this.loader = false;
      } else {
        this.loader = false;
      }
    }, err => {
      this.loader = false;
    })
  }

}
